import React from "react";

const CloseIcon = (props) => {
  const { color = "#475569" } = props;

  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.2929 5.29295C17.6834 4.90243 18.3164 4.90244 18.7069 5.29295C19.0975 5.68347 19.0975 6.31648 18.7069 6.70701L13.414 12L18.7069 17.2929L18.7753 17.3691C19.0956 17.7619 19.0731 18.3409 18.7069 18.707C18.3408 19.0731 17.7618 19.0957 17.3691 18.7754L17.2929 18.707L11.9999 13.414L6.70695 18.707C6.31642 19.0975 5.68341 19.0975 5.29288 18.707C4.90238 18.3165 4.90237 17.6835 5.29288 17.2929L10.5859 12L5.29288 6.70701L5.22453 6.63084C4.90417 6.23806 4.92677 5.65906 5.29288 5.29295C5.659 4.92683 6.238 4.90424 6.63078 5.22459L6.70695 5.29295L11.9999 10.5859L17.2929 5.29295Z"
          fill={color}
        />
      </svg>
    </>
  );
};

export default CloseIcon;
